import React from 'react';

import { useBlockName } from '@wp-block-builder/editor/hooks';
import { type TBlock } from '@wp-block-builder/package';
import { LoopIterationLayout, SectionBlockLayout } from '@wp-block-builder/stores/BlockLayoutStore';

import { EditableCanvas } from '../Container/ContainerEditableBlock';
import BlockPlaceholder from '../helpers/BlockPlaceholder';

import LoopRunner from './LoopRunner';

type Props = {
  block: Extract<TBlock, { type: 'LoopContainer' }>;
  BlockComponent: (props: { block: TBlock }) => JSX.Element;
};
export default function LoopContainerEditableBlock({ block, BlockComponent }: Props) {
  const name = useBlockName(block.id);
  const { loopTemplate, loopArgumentName, loopIndexName } = block.props || {};
  return (
    <LoopRunner
      placeholder={<BlockPlaceholder type="LoopContainer" />}
      loopTemplate={loopTemplate}
      loopArgumentName={loopArgumentName}
      loopIndexName={loopIndexName}
      renderLoopIteration={(index) => {
        const child = <EditableCanvas blocksArrayName={`${name}.props.blocks`} BlockComponent={BlockComponent} />;
        if (index === 0) {
          return <SectionBlockLayout>{child}</SectionBlockLayout>;
        }
        return <LoopIterationLayout>{child}</LoopIterationLayout>;
      }}
    />
  );
}
